var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6955 11.0453C5.81227 11.1621 5.96018 11.2166 6.10809 11.2166C6.25601 11.2166 6.4117 11.1621 6.52069 11.0453C6.74645 10.8195 6.74645 10.4459 6.52069 10.2201L2.79174 6.49116H14.6169C14.9361 6.49116 15.2008 6.22648 15.2008 5.9073C15.2008 5.58812 14.9361 5.32344 14.6169 5.32344H2.79177L6.52069 1.59452C6.74645 1.36876 6.74645 0.995086 6.52069 0.769326C6.29493 0.543566 5.92126 0.543566 5.6955 0.769326L0.970101 5.49472C0.744341 5.72048 0.744341 6.09415 0.970101 6.31991L5.6955 11.0453Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionBack);
export default __webpack_public_path__ + "static/media/UnionBack.28fdfc0a07d311e75a87c720b95b13be.svg";
export { ForwardRef as ReactComponent };